import { FC, memo } from 'react';
import classnames from 'classnames';

import IconColor from 'bloko/blocks/icon/colors.d';
import loggingNotValidIcon from 'bloko/blocks/icon/loggingNotValidIcon';
import makeSocialComponent from 'bloko/blocks/icon/variants/social/Switcher';
import { SocialScale, SocialAppearance, SocialView, SocialInvariants } from 'bloko/blocks/icon/variants/social/types.d';

import styles from 'bloko/blocks/icon/icon.less';

interface SocialProps {
    view: SocialView;
    initial?: IconColor;
    highlighted?: IconColor;
    source?: string;
    scale?: SocialScale;
    appearance?: SocialAppearance;
}

type ComponentProps<T> = {
    [Prop in keyof T]: T[Prop];
};

type SocialPropsByView = SocialProps & ComponentProps<SocialInvariants>;

const SocialIcon: FC<SocialPropsByView> = ({
    view,
    scale = SocialScale.Small,
    initial = IconColor.Black,
    highlighted,
    appearance = SocialAppearance.Default,
    source,
    ...iconProps
}) => {
    const classNames = {
        [styles[`bloko-icon_initial-${initial}`]]: initial,
    };

    if (highlighted) {
        classNames[styles[`bloko-icon_highlighted-${highlighted}`]] = highlighted;
    }

    const props = {
        ...iconProps,
        className: classnames(styles['bloko-icon'], classNames),
    };

    const iconSwitcherProps = {
        view,
        scale,
        appearance,
        ...iconProps,
    };

    const Social = makeSocialComponent(iconSwitcherProps);

    if (Social) {
        return <Social {...props} />;
    }

    loggingNotValidIcon(iconSwitcherProps);
    return null;
};

export default memo(SocialIcon);
